(function() {
  'use strict';

  angular
    .module('media.mediaControlsCtrl', ['media.mediaControlsDirective'])
    .controller('MediaControlsCtrl', MediaControlsCtrl);

  MediaControlsCtrl.$inject = ['$scope', 'Navigation', 'MobileHelper', 'Sension', '$timeout', '$rootScope', 'gettext',
    'translationService'];

  function MediaControlsCtrl($scope, Navigation, MobileHelper, Sension, $timeout, $rootScope, gettext,
                             translationService) {
    var translate = translationService.sprintf;
    var mediaState = null;
    var mediaControl = null;
    var states = null;
    var seekToTime = null;
    var timePriorToSeek = null;
    var numberOfGoodCurrentTimeReadsAfterSeek = 0; // need this to verify we can start updating playhead again after seek.
    var showResolutionToggle = false;
    var nextClickPoint = null;
    var seekTimeoutPromise = null;

    $scope.justEnded = false;

    Navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
      if (mediaControl && mediaControl.getDuration && mediaControl.canPlay && mediaControl.canPlay()) {
        mediaControl.trackProgress = !mediaControl.isPreview && !$scope.completionInfo &&
          //mediaControl.slide.status != 117000200 /*Completed*/ &&
          (mediaControl.getDuration() - 1) > $scope.currentSlide.progressSeconds &&
          (Navigation.slideIndex == (Navigation.numUnlockedSlides - 1)) &&
          Navigation.playerType == Navigation.playerTypes.trainee;
      }

      if (navigateTo == Navigation.directions.exit)
        return true;

      // Just go to next slide if using native full screen video player.
      if (MobileHelper.willGoNativeFullScreen())
        return true;

      // You can always navigate previous.
      if (navigateTo !== Navigation.directions.next)
        return true;

      // If we're allowing free navigation (i.e. trainer preview then they can always navigate next.
      if (Navigation.freeNavigation)
        return true;

      // You can't navigate past the number of unlocked slides.
      if (Navigation.slideIndex > (Navigation.numUnlockedSlides - 1))
        return false;

      if (!mediaControl || !mediaState)
        return false;

      // Next 2 if blocks are for crazy Sension/no fast forward cases of not showing the right arrow.
      // TODO: Refactor by saving more state so we know when they've already viewed the entire slide without having
      // gone to the next slide.

      // When the media is starting, before it's played back we don't want to see the right arrow at all. It can't
      // even blink. The only exception to this is when we're past this slide (e.g. number of unlocked slides is
      // greater than current slide index) or the cModule is already complete and is being review.
      if ((Sension.requireEngagement() || !$scope.cModule.allowFastForward) &&
        mediaState.state == mediaState.states.starting &&
        !$scope.completionInfo &&
        Navigation.slideIndex == (Navigation.numUnlockedSlides - 1) &&
        !Navigation.isPreview)
        return false;

      // When media is playing, don't show right arrow. Exceptions are when we've already viewed the entire slide
      // (as noted by our progressSeconds being the same as the duration), when we're past this slide (e.g. number
      // of unlocked slides is greater than current slide index) or the cModule is already complete and is being review.
      if ((Sension.requireEngagement() || !$scope.cModule.allowFastForward) &&
        mediaState.state == mediaState.states.playing &&
        (!mediaControl.getDuration || ((mediaControl.getDuration() - 1) > $scope.currentSlide.progressSeconds && mediaControl.getDuration() != 0)) &&
        !$scope.completionInfo &&
        Navigation.slideIndex == (Navigation.numUnlockedSlides - 1) &&
        !Navigation.isPreview)
        return false;

      return true;
    });

    $scope.$watch('mediaState', function(newMediaState) {
      if (!newMediaState) return;

      mediaState = newMediaState;
      states = mediaState.states;
    });

    $scope.$watch('mediaState.state', function(state) {
      if (!state || !mediaControl) return;

      ({
        playing: mediaControl.play,
        paused: mediaControl.pause,
        ended: onEnded
      }[state] || angular.noop)();
    });

    $scope.$watch('mediaState.fullscreen', function(value) {
      if (value && $scope.setControlsSizes)
        $scope.setControlsSizes();
    });

    $scope.$watch('mediaControl', function(newMediaControl) {
      if (!newMediaControl || mediaControl === newMediaControl) return;
      mediaControl = newMediaControl;

      mediaControl.play = function play() {
        if (!mediaControl.rawPlay)
          return;

        // In FF8 somehow this is getting called as soon as the video ends with no stack
        // To deal with this just exit out if we get here within a second of the video ending.
        if ($scope.justEnded)
          return;

        mediaState.state = states.playing;

        if ($scope.atEnd()) {
          mediaControl.seek(0);
        }

        mediaControl.rawPlay();
        $scope.onPlaying();
        calcNextClickPoint();
      };

      mediaControl.pause = function pause() {
        if (!mediaControl.rawPause || !$scope.onPaused)
          return;

        mediaControl.rawPause();
        $scope.onPaused();
        mediaState.state = closeToEnd() ? states.ended : states.paused;
      };

      mediaControl.seek = function seek(time, cb) {
        if (seekTimeoutPromise) {
          $timeout.cancel(seekTimeoutPromise);
          seekTimeoutPromise = null;
        }
        if (!mediaControl.canPlay()) {
          seekTimeoutPromise = $timeout(function() {
            mediaControl.seek(time, cb);
          }, 50);
          return;
        }
        var duration = $scope.getDirectiveDuration();
        if (isNaN(duration))
          time = Math.max(0.05, time);
        else
          time = Math.min(duration, Math.max(0.05, time));
        timePriorToSeek = $scope.getDirectiveCurrentTime();
        seekToTime = time;
        $scope.updateDirectiveCurrentTime(time);
        mediaControl.rawSeek(time);
        $scope.setScrubber();
        calcNextClickPoint();
        if (cb) cb();
      };

      mediaControl.rewindTooltip = translate(gettext('Rewind'));
      mediaControl.resolutionTooltip = translate(gettext('Change Video Quality'));
    });

    function onEnded() {
      $scope.justEnded = true;
      $timeout(function() {
        $scope.justEnded = false;
      }, 1000);
      $scope.mediaControl.pause(); // TODO: Iverson I dont think this is needed
      seekToTime = null;
      timePriorToSeek = null;
      $scope.updateDirectiveCurrentTime($scope.getDirectiveDuration());
      $scope.setScrubber();
    }

    $scope.atEnd = function() {
      if (!$scope.getDirectiveDuration || !$scope.getDirectiveCurrentTime)
        return false;

      var duration = $scope.getDirectiveDuration();
      var currentTime = $scope.getDirectiveCurrentTime();
      return duration > 0 && currentTime >= duration;
    }

    function closeToEnd() {
      // Sometimes video stops because it's reached its end before reported duration.
      var duration = $scope.getDirectiveDuration();
      var currentTime = $scope.getDirectiveCurrentTime();
      return duration > 0 && currentTime >= (duration - 0.5);
    }

    $scope.mediaControls = function() {
      return mediaState && mediaControl;
    };

    $scope.isPaused = function() {
      return mediaState.state === states.paused || mediaState.state === states.ended;
    };

    $scope.getDisabledState = function() {
      return ((Sension.requireEngagement() && !Sension.isEngaged()) || $scope.justEnded || mediaState.deferredSeekTime) ? 'disabled' : '';
    };

    $scope.getPlayButtonTooltip = function() {
      if (!mediaState) return null;
      var text = (mediaState.state === states.paused || mediaState.state === states.ended) ? 'Play' : 'Pause';
      return translate(gettext(text));
    };

    $scope.playPauseClick = function() {
      if ((Sension.requireEngagement() && !Sension.isEngaged()) || $scope.justEnded || mediaState.deferredSeekTime)
        return;

      mediaState.state = {
        playing: states.paused,
        paused: states.playing,
        ended: states.playing
      }[mediaState.state] || mediaState.state;
    };

    $scope.rewindClick = function() {
      mediaControl.seek($scope.getDirectiveCurrentTime() - 10);
    };

    $scope.showChangeResolution = function() {
      var newShowResolutionToggle = !MobileHelper.supportsHLS() && mediaState &&
        mediaState.availableResolutions && mediaState.availableResolutions.length > 1;

      if (showResolutionToggle != newShowResolutionToggle) {
        showResolutionToggle = newShowResolutionToggle;

        // If value changed then change the control sizes after the DOM changes.
        $timeout($scope.setControlsSizes);
      }

      return !!showResolutionToggle;
    };

    $scope.changeResolutionClick = function(type) {
      if (!mediaState || !type)
        return;

      mediaState.sourceType = type;
      $rootScope.sourceType = mediaState.sourceType;
    };

    $scope.isSelectedResolution = function(type) {
      if (!mediaState || !type)
        return false;
      return mediaState.sourceType == type;
    };

    $scope.fullScreen = function() {
      return mediaState.fullscreen !== mediaState.fullscreenModes.none;
    };

    $scope.getFullScreenButtonTitle = function() {
      if (!mediaState) return null;
      var text = mediaState.fullscreen == mediaState.fullscreenModes.none ? 'Enter Full Screen' : 'Exit Full Screen';
      return translate(gettext(text));
    };

    $scope.showFullscreenButton = function() {
      if (!mediaControl || !mediaControl.slide || !mediaState)
        return false;

      var isVideoSlide = mediaControl.slide.__type === 'VideoSlideInfo' ||
        mediaControl.slide.__type === 'PPTVideoSlideInfo' ||
        mediaControl.slide.__type === 'YouTubeSlideInfo';

      return !MobileHelper.isMobileDevice() && isVideoSlide;
    };

    $scope.toggleFullscreen = function() {
      if (!mediaControl || !mediaState)
        return;

      if (mediaState.fullscreen == mediaState.fullscreenModes.none)
        mediaControl.requestFullscreen();
      else
        mediaControl.exitFullscreen();
    };

    $scope.isMuted = function() {
      return $rootScope.isMuted;
    };

    $scope.getMuteButtonTooltip = function() {
      var text = $rootScope.isMuted ? 'Unmute' : 'Mute';
      return translate(gettext(text));
    };

    $scope.toggleMuteClick = function() {
      mediaControl.toggleMute();
    };

    $scope.getNumberOfButtonsClass = function() {
      var numLeftButtons = 2;
      if ($scope.canMute)
        numLeftButtons = numLeftButtons + 1;

      var numButtonsRight = 0;
      if ($scope.showFullscreenButton())
        numButtonsRight = numButtonsRight + 1;
      if ($scope.showChangeResolution())
        numButtonsRight = numButtonsRight + 1;

      return 'has-' + numLeftButtons + '-buttons-left' + ' has-' + numButtonsRight + '-buttons-right';
    };

    $scope.getDurationDigitsClass = function() {
      if (!$scope.getDirectiveDuration) return null;
      return $scope.getDirectiveDuration() >= 3600 ? 'duration-over-hour' : null;
    };

    function calcNextClickPoint() {
      nextClickPoint = null;
      if (!$scope.getDirectiveCurrentTime)
        return;

      var currentTime = $scope.getDirectiveCurrentTime();
      var clickPoints = mediaState.clickPoints;
      if (clickPoints) {
        for (var i = 0; i < clickPoints.length; i++) {
          if (currentTime <= clickPoints[i]) {
            nextClickPoint = clickPoints[i];
            break;
          }
        }
      }
    }

    $scope.atClickPoint = function() {
      return nextClickPoint !== null && $scope.getDirectiveCurrentTime() >= nextClickPoint;
    };

    $scope.getProcessedCurrentTime = function() {
      // When seeking the currentTime it reports will be off for a while until it finishes seeking. The
      // insane logic below handles this so the playhead looks smooth and doesn't jump around during the
      // seek. We've previously handled this by ignoring time updates until we're sure we have enough data
      // from the video to get a good read from the element. This didn't work for youtube because it's a
      // black box and doesn't have any methods/events to get this sort of information. The same is now true
      // for regular video and narration since we use libraries that fall back to flash. Thus, best to
      // solve this once in the controls and ignore the tech giving us the current time.

      var duration = $scope.getDirectiveDuration();
      var currentTime;
      var elementCurrentTime = mediaControl.getCurrentTime();

      if (seekToTime)
        currentTime = seekToTime;
      else if (mediaState.deferredSeekTime)
        currentTime = mediaState.deferredSeekTime;
      else
        currentTime = mediaControl.getCurrentTime();

      if (!isNullOrUndefined(seekToTime) && !isNullOrUndefined(timePriorToSeek)) {
        if (Math.abs(timePriorToSeek - seekToTime) < 1) {
          // If we're seeking in either direction less than a second from where we started don't try
          // to manipulate the playhead at all. Too risky.
          seekToTime = null;
          timePriorToSeek = null;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
          currentTime = elementCurrentTime;
        } else if (duration - seekToTime < 1) {
          // If we're within a second of the end of the clip then don't try to manipulate the playhead
          // at all. Too risky.
          seekToTime = null;
          timePriorToSeek = null;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
          currentTime = elementCurrentTime;
        } else if (Math.abs(timePriorToSeek - elementCurrentTime) <= 1) {
          // If the current time from element is within a second of where we were when we executed the
          // seek then leave the playhead at the time to which we're seeking.
          currentTime = seekToTime;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
        } else if (Math.abs(elementCurrentTime - seekToTime) < 0.25) {
          // Often it just sits at the time you're seeking to for a while before the madness surrounding
          // the reported current time begins. If it looks like we're in this state then leave the playhead at
          // the time to which we're seeking and keep waiting for forward movement.
          currentTime = seekToTime;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
        } else if (elementCurrentTime < seekToTime) {
          // We're not good to go unless the time the element is reporting is greater than the time to
          // which we seeked so if we still haven't passed it we definitely aren't ready to regularly
          // update the playhead.
          currentTime = seekToTime;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
        } else if (numberOfGoodCurrentTimeReadsAfterSeek < 5) {
          // Unless something insane happened the time should be around where we told the player to seek.
          // Count up until this happens 5 times while still leaving the playhead at the time to which
          // we're seeking.
          numberOfGoodCurrentTimeReadsAfterSeek++;
          currentTime = seekToTime;
        } else {
          // We're confident the current time being reported is correct. Update the playhead.
          seekToTime = null;
          timePriorToSeek = null;
          numberOfGoodCurrentTimeReadsAfterSeek = 0;
          currentTime = elementCurrentTime;
        }
      } else {
        currentTime = elementCurrentTime;
      }

      return currentTime;
    };

    function isNullOrUndefined(val) {
      return val === null || val === undefined;
    }

    $scope.$on('$destroy', function() {
      if (seekTimeoutPromise) {
        $timeout.cancel(seekTimeoutPromise);
        seekTimeoutPromise = null;
      }
    });
  }
})();
